import React from "react";
import {
  Row,
  Col,
  FormGroup,
  ControlLabel,
  FormControl,
  Button,
} from "react-bootstrap";
import AddressesTable from "./AddressTable";
const NewCustomerAddressSection = ({
  customer,
  address,
  setAddress,
  addAddress,
  removeAddress,
}) => {
  const addressInputRef = React.useRef(null);

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      addAddress();
    }
  };

  return (
    <Col xs={12}>
      <FormGroup>
        {customer?.addresses?.length > 0 && (
          <AddressesTable
            addresses={customer.addresses}
            removeAddress={removeAddress}
          />
        )}
        <ControlLabel>آدرس ها</ControlLabel>
        <Row>
          <Col xs={9}>
            <FormControl
              type="text"
              placeholder="آدرس جدید"
              value={address}
              onKeyPress={handleKeyPress}
              ref={addressInputRef}
              onChange={(e) => setAddress(e.target.value)}
            />
          </Col>
          <Col xs={2}>
            <Button
              onClick={addAddress}
              bsStyle="info"
              style={{ width: "100%" }}
            >
              اضافه کردن آدرس
            </Button>
          </Col>
        </Row>
      </FormGroup>
    </Col>
  );
};

export default NewCustomerAddressSection;
